/** Запас у конца ленты, в пределах которого она считается прокрученной вниз. */
const BOTTOM_THRESHOLD_PX = 80;

interface ScrollBox {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

/**
 * Лента у конца: новое сообщение прокручивает её вниз. Если сотрудник
 * прокрутил вверх и читает старое, лента остаётся на месте.
 */
export function isNearBottom(box: ScrollBox): boolean {
  return (
    box.scrollHeight - box.scrollTop - box.clientHeight <= BOTTOM_THRESHOLD_PX
  );
}
